<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="车辆品牌" prop="name">
            <el-input placeholder="请输入车辆品牌" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                rule: {
                    id: 0,
                    name: '',
                },
                rules: {
                    name: {required: true, message: '请输入车辆品牌'},
                },
            }
        },
        created() {
            if(this.$route.params.id) {
                if(!!this.$store.state.editInfo) {
                    this.rule = this.$store.state.editInfo
                }else {
                    this.$router.push('/car/brand/index');
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/car-brand/save',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/car/brand/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/car-brand/update',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/car/brand/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                        
                    }
                });
            },
            block() {
                this.$router.go(-1);
            },
        }
    }
</script>